import { branch, renderComponent } from 'recompose';
import { ErrorPage } from 'pages/Bundles';

export default branch((props) => props.statusCode > 200, renderComponent(ErrorPage));
